const QR_CODE_HOST_SHAPE = /^[a-z0-9-]+(?:\.[a-z0-9-]+)*\.([a-z]{2,})(?:[/?:#]|$)/i;

const QR_CODE_URL_TLDS = new Set([
  'com',
  'net',
  'org',
  'io',
  'me',
  'ly',
  'co',
  'es',
  'it',
  'fr',
  'de',
  'pt',
  'uk',
  'eu',
  'info',
  'link',
  'page',
  'app',
  'xyz',
  'gl',
  'to',
  'be',
  'nl',
  'cat',
]);

// A known TLD rather than "any letters", so all-letter operator codes like IT.SIAE.ROMA and
// ticket.code are not read as hosts.
export const isQrCodeHostLike = (value: string) => {
  const groups = QR_CODE_HOST_SHAPE.exec(value);
  return groups !== null && QR_CODE_URL_TLDS.has(groups[1].toLowerCase());
};
